"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _v = _interopRequireDefault(require("uuid/v4"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

var _utils = require("../../../../../../../common/utils");

var _PostDetails = _interopRequireDefault(require("./PostDetails"));

var _NewPostsList = _interopRequireDefault(require("./NewPostsList"));

require("../styles/_create-posts.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var createEmptyPostItem = function createEmptyPostItem() {
  return {
    itemId: (0, _v.default)()
  };
};

var canCreatePosts = function canCreatePosts(posts) {
  return !!posts.length && posts.every(_utils.validatePostData);
};

var CreateNewPostsModal = /*#__PURE__*/function (_Component) {
  _inherits(CreateNewPostsModal, _Component);

  function CreateNewPostsModal(props) {
    var _this;

    _classCallCheck(this, CreateNewPostsModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CreateNewPostsModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "createNewPostItem", function () {
      _this.setState(function (_ref) {
        var posts = _ref.posts,
            selectedItemId = _ref.selectedItemId;
        var newPostItem = createEmptyPostItem();
        var newSelectedPostItemId = !posts.length || !selectedItemId ? newPostItem.itemId : selectedItemId;
        return {
          posts: [].concat(_toConsumableArray(posts), [newPostItem]),
          selectedItemId: newSelectedPostItemId
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectPostItem", function (itemId) {
      _this.setState({
        selectedItemId: itemId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeListItem", function (itemId) {
      _this.setState(function (_ref2) {
        var posts = _ref2.posts,
            selectedItemId = _ref2.selectedItemId;

        var newPosts = _toConsumableArray(posts);

        var index = newPosts.findIndex(function (postItem) {
          return postItem.itemId === itemId;
        });

        if (index === -1) {
          return {};
        }

        var isRemoveSelectedPost = selectedItemId === posts[index].itemId;
        newPosts.splice(index, 1);
        var newSelectedPostItemId = isRemoveSelectedPost ? newPosts[0] && newPosts[0].itemId : selectedItemId;
        return {
          posts: newPosts,
          selectedItemId: newSelectedPostItemId
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "savePostItemDetails", function (postItemPayload) {
      _this.setState(function (_ref3) {
        var posts = _ref3.posts,
            selectedItemId = _ref3.selectedItemId;

        var newPosts = _toConsumableArray(posts);

        var index = newPosts.findIndex(function (postItem) {
          return postItem.itemId === selectedItemId;
        });

        if (index === -1) {
          return {};
        }

        newPosts[index] = Object.assign({}, newPosts[index], postItemPayload);
        return {
          posts: newPosts
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedPostItem", function () {
      var _this$state = _this.state,
          posts = _this$state.posts,
          selectedItemId = _this$state.selectedItemId;
      return posts.find(function (postItem) {
        return postItem.itemId === selectedItemId;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addThumbnailToInspiration", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
        var organisationId, inspirationId, file, _this$props, apolloClient, updateInspiration;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                organisationId = _ref5.organisationId, inspirationId = _ref5.inspirationId, file = _ref5.file;
                _this$props = _this.props, apolloClient = _this$props.apolloClient, updateInspiration = _this$props.updateInspiration;
                _context.prev = 2;
                _context.next = 5;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apolloClient,
                  file: file,
                  bucketKey: (0, _utils.getCustomThumbnailKey)({
                    organisationId: organisationId,
                    inspirationId: inspirationId
                  }),
                  organisationId: organisationId
                });

              case 5:
                return _context.abrupt("return", updateInspiration({
                  inspirationId: inspirationId,
                  input: {
                    isCustomThumbnail: true
                  }
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", (0, _commonReact.notify)({
                  content: 'Something went wrong.',
                  type: 'error'
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 8]]);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "uploadCustomThumbnails", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(createdPosts) {
        var posts, postsWithThumbnailFiles;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                posts = _this.state.posts;
                postsWithThumbnailFiles = createdPosts.map(function (createdPost, i) {
                  return {
                    inspirationId: createdPost.inspirationId,
                    organisationId: createdPost.organisationId,
                    file: posts[i].thumbnailFile
                  };
                }).filter(function (_ref7) {
                  var file = _ref7.file;
                  return Boolean(file);
                });
                return _context2.abrupt("return", Promise.all(postsWithThumbnailFiles.map(_this.addThumbnailToInspiration)));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "createInspirations", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props2, createInspirations, organisationId, posts, postsBatch, _ref9, _ref9$data, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props2 = _this.props, createInspirations = _this$props2.createInspirations, organisationId = _this$props2.organisationId;
              posts = _this.state.posts;
              postsBatch = posts.map(function (post) {
                var title = post.title,
                    description = post.description,
                    tagLine = post.tagLine,
                    referenceLink = post.referenceLink,
                    assetId = post.assetId,
                    embedCode = post.embedCode,
                    sourceLink = post.sourceLink,
                    campaigns = post.campaigns;
                return {
                  organisationId: organisationId,
                  title: title,
                  description: description,
                  tagLine: tagLine,
                  referenceLink: referenceLink,
                  assetId: assetId,
                  embedCode: embedCode,
                  sourceLink: sourceLink,
                  campaignIds: campaigns && Array.isArray(campaigns) ? campaigns.map(function (campaign) {
                    return campaign.value;
                  }) : []
                };
              });
              _context3.next = 5;
              return createInspirations(postsBatch);

            case 5:
              _ref9 = _context3.sent;
              _ref9$data = _ref9.data;
              data = _ref9$data === void 0 ? {} : _ref9$data;
              return _context3.abrupt("return", data.createInspirations);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$props3, onToggleModal, refetchPosts, createdPosts, firstPost;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props3 = _this.props, onToggleModal = _this$props3.onToggleModal, refetchPosts = _this$props3.refetchPosts;
              _context4.next = 3;
              return _this.createInspirations();

            case 3:
              createdPosts = _context4.sent;

              if (!(!createdPosts || !createdPosts.length)) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", null);

            case 6:
              _context4.next = 8;
              return _this.uploadCustomThumbnails(createdPosts);

            case 8:
              firstPost = createEmptyPostItem();

              _this.setState({
                posts: [firstPost],
                selectedItemId: firstPost.itemId
              });

              refetchPosts();
              return _context4.abrupt("return", onToggleModal());

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    var _firstPost = createEmptyPostItem();

    _this.state = {
      posts: [_firstPost],
      selectedItemId: _firstPost.itemId
    };
    return _this;
  }

  _createClass(CreateNewPostsModal, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          modalVisible = _this$props4.modalVisible,
          onToggleModal = _this$props4.onToggleModal;
      var _this$state2 = this.state,
          posts = _this$state2.posts,
          selectedItemId = _this$state2.selectedItemId;
      var selectedPost = this.getSelectedPostItem();
      return _react.default.createElement("div", {
        className: "create-post"
      }, _react.default.createElement(_uiKit.FormModal, {
        key: "crete-new-posts-modal",
        visible: modalVisible,
        onClose: onToggleModal,
        title: "Create New Posts",
        onSave: this.handleSave,
        saveText: "SAVE & CLOSE",
        saveDisabled: !canCreatePosts(posts),
        stayOpenOnSave: true
      }, _react.default.createElement("div", {
        className: "create-post__content"
      }, _react.default.createElement(_NewPostsList.default, {
        postsList: posts,
        selectedItemId: selectedItemId,
        onAddItemClick: this.createNewPostItem,
        onItemClick: this.selectPostItem,
        onItemRemove: this.removeListItem
      }), selectedPost && _react.default.createElement(_PostDetails.default, {
        key: selectedPost.itemId,
        post: selectedPost,
        onSave: this.savePostItemDetails
      }))));
    }
  }]);

  return CreateNewPostsModal;
}(_react.Component);

exports.default = CreateNewPostsModal;